export const getHost = (req) => {
  const { headers } = req;
  return (
    headers['x-forwarded-host'] || headers['x-original-host'] || headers.host
  );
};

export const getDomain = (req) => {
  const currentHost = getHost(req);
  if (currentHost.startsWith('localhost')) {
    return 'localhost';
  }

  const domainArray = currentHost.split('.');
  const domain = domainArray.slice(-2).join('.'); // get the last part of the domain for example 'ving.se', 'ntlg.com' or 'acctest.int'

  return domain;
};

export const getDomainInBrowser = () => {
  if (typeof window === 'undefined') {
    throw new Error('getDomainInBrowser should be used in browser only');
  }
  const currentHost = window.location.host;
  if (window.location.host.includes('localhost')) {
    return currentHost;
  }
  const domain = window.location.host.split('.').splice(-2).join('.'); // get the last part of the domain for example 'ving.se', 'ntlg.com' or 'acctest.int'
  return domain;
};
